
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getGuides",
      resolverType: "query",
      routePath: "/getGuides",
      httpMethod: "POST",
    });
  